/**
 * Role V2 Repository - GraphQL Fragments
 *
 * Reusable field selections for Role queries and mutations.
 * Ensures 100% field parity with backend GraphQL schema.
 */

import { gql } from '@apollo/client';

export const ROLE_FIELDS_FRAGMENT = gql`
  fragment RoleFields on Role {
    id
    roleName
    parentId
    originalId
    recordVersion
    isActive
    requiredForApprovals
    approvalLimits {
      maxTransactionAmount
      maxDocumentSizeMb
      maxParallelApprovals
    }
    hierarchyLevel
    description
    roleCategory
    permissions {
      resourceType
      action
      scope
      condition
    }
    permissionMode
    resourceScopes {
      resourceType
      resourceIds
      constraintType
    }
    inheritsFrom
    active
    effectiveDateRange {
      startDate
      endDate
    }
    createdBy
    createdAt
    updatedBy
    updatedAt
    version
    metadata
    tags
  }
`;
